import {
  IAppData,
  IWidgetControllerConfig,
  IWixAPI,
} from '@wix/native-components-infra/dist/src/types/types';
import { Api, ApiTypes } from '@wix/social-groups-api';
import { AppRootData } from '../types';
import { getBaseUrl } from '@wix/social-groups-common';

class GroupsController {
  private readonly wixCodeApi: IWixAPI;
  private readonly appParams: IAppData;
  private readonly setProps: (newProps: Partial<AppRootData>) => void;
  private api: Api;

  constructor(controllerConfig: IWidgetControllerConfig) {
    const { appParams, setProps, wixCodeApi } = controllerConfig;
    this.wixCodeApi = wixCodeApi;
    this.appParams = appParams;
    this.setProps = setProps;
    this.api = new Api(appParams.instance, getBaseUrl(wixCodeApi));
  }

  public refreshApiToken(instance: string) {
    this.api = new Api(instance, getBaseUrl(this.wixCodeApi));
  }

  public goToGroup = (groupId: string) => {
    this.wixCodeApi.location.to(`/group/${groupId}/discussion`);
  };

  public createGroup = async (
    details: ApiTypes.v1.GroupDetails,
    settings: ApiTypes.v1.GroupSettings,
  ) => {
    this.setProps({
      isGroupCreating: true,
    });
    try {
      const { data } = await this.api.createGroup(details, settings);
      this.goToGroup(data.groupId);
    } catch (e) {
      // TODO: handle error
      console.error(e);
    } finally {
      this.setProps({
        isGroupCreating: false,
      });
    }
  };

  public async fetchGroups() {
    return (await this.api.getGroupList()).data.groups;
  }
}

export default GroupsController;
